import { useCallback } from 'react';

export const useSmoothScroll = () => {
  const scrollToAnchor = useCallback((anchorId: string) => {
    const element = document.getElementById(anchorId);
    if (!element) return;
    
    // Account for fixed navigation bar height plus additional spacing
    const navHeight = 100;
    const additionalOffset = 20;
    const totalOffset = navHeight + additionalOffset;
    
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - totalOffset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }, []);

  return { scrollToAnchor };
};
